'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SimpleTab.scss');

var SimpleTab = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(SimpleTab, _PureComponent);

  function SimpleTab() {
    (0, _classCallCheck3.default)(this, SimpleTab);
    return (0, _possibleConstructorReturn3.default)(this, (SimpleTab.__proto__ || (0, _getPrototypeOf2.default)(SimpleTab)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimpleTab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          title = _props.title,
          active = _props.active,
          onClick = _props.onClick;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _bind2.default)(styles.tab, (0, _defineProperty3.default)({}, styles.active, active), className),
          onClick: onClick
        },
        title
      );
    }
  }]);
  return SimpleTab;
}(_react.PureComponent), _class.propTypes = {
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  title: _propTypes2.default.string
}, _class.defaultProps = {
  onClick: _noop3.default
}, _temp);
exports.default = SimpleTab;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleTab/SimpleTab.js
// module id = 518
// module chunks = 1